// import initEventsPageAndFilters from './js-components/eventsPageAndFilters';
import initGsapAnims from './js-components/gsapAnims';
import initGsapAnimsAboutPage from './js-components/gsapAnimsAboutPage';
import initFlickitySliders from './js-components/flickitySliders';
import initGlightbox from './js-components/glightbox';
import initModals from './js-components/modals';
import initAddToFavorite from './js-components/addToFavorite';
import initScrollTo from './js-components/scrollTo';
import initCountUp from './js-components/countUp';
import initLightpick from './js-components/lightpickRangePicker';

class App {
    init() {
        // Add loaded to body and delete spinner
        document.body.classList.add('loaded');

        // initEventsPageAndFilters();
        initGsapAnims();
        initGsapAnimsAboutPage();
        initFlickitySliders();
        initGlightbox();
        initModals();
        initAddToFavorite();
        initScrollTo();
        initCountUp();
        initLightpick();

        this.initAOS();

        this.initFollowNav();

        this.initTrackingActions();

        const detailsHero = document.querySelector('.events-details-hero');
        const fixedBar = document.querySelector('.fixed-follow-bar');

        // When scroll past hero
        if (detailsHero && fixedBar) {
            const heroHeight = detailsHero.offsetHeight;

            window.addEventListener('scroll', () => {
                if (window.scrollY > heroHeight) {
                    fixedBar.classList.add('is-active');
                } else {
                    fixedBar.classList.remove('is-active');
                }
            });
        }

        const burger = document.querySelector('.burger');
        const mobileNav = document.querySelector('.mobile-nav');
        const mainNav = document.querySelector('.main-nav');
        const topNav = document.querySelector('.top-nav');

        burger.addEventListener('click', () => {
            burger.classList.toggle('is-active');
            mainNav.classList.toggle('is-active');
            mobileNav.classList.toggle('is-active');
            topNav.classList.toggle('is-active');
            document.body.classList.toggle('is-fixed');
        });

        const searchWrap = document.querySelector('.search-wrap');
        const submit = searchWrap.querySelector('form [type="submit"]');

        if (searchWrap && submit) {
            submit.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                searchWrap.querySelector('form input').focus();

                searchWrap.classList.add('is-active');
                document.body.classList.add('is-search-open');
            });

            searchWrap.querySelector('form input').addEventListener('blur', () => {
                // searchWrap.classList.remove('is-active');
                // document.body.classList.remove('is-search-open');
            });

            // Close search on click outside
            document.addEventListener('click', (e) => {
                if (!searchWrap.contains(e.target)) {
                    searchWrap.classList.remove('is-active');
                    document.body.classList.remove('is-search-open');
                }
            });
        }

        const unfoldTriggers = document.querySelectorAll('[data-unfold-trigger]');

        unfoldTriggers.forEach((trigger) => {
            trigger.addEventListener('click', () => {
                const uid = trigger.dataset.unfoldTrigger;

                const unfoldContent = document.querySelector(`[data-unfold-row="${uid}"]`);

                if (unfoldContent) {
                    unfoldContent.classList.toggle('is-active');
                    trigger.classList.toggle('is-active');
                }
            });
        });

        if (document.querySelector('.Lieux')) {
            document.querySelector('.Lieux').addEventListener('click', (e) => {
                const target = e.target;
                if (target.closest('.lieux-btns')) {
                    setTimeout(() => {
                        this.initAOS();
                        initFlickitySliders();
                        initGsapAnims();

                        const scrollToPosition =
                            document.querySelector('.lieux-split').getBoundingClientRect().top +
                            window.scrollY;

                        window.scrollTo({
                            top: scrollToPosition,
                            behavior: 'smooth',
                        });
                    }, 1500);
                }
            });
        }

        // HomePage video
        const videoRef = document.querySelector('[data-load-video]');

        if (!videoRef) {
            return;
        }

        // Delay videos load
        setTimeout(() => {
            videoRef.setAttribute('src', videoRef.getAttribute('data-src'));
        }, 10);
    }

    initAOS() {
        setTimeout(() => {
            // In View Observer trigger Anims
            const animSelector = '[data-inview]';
            const animElements = [].slice.call(document.querySelectorAll(animSelector));

            const animObserver = new IntersectionObserver(function (elems) {
                elems.forEach(function (elem) {
                    if (elem.intersectionRatio > 0) {
                        elem.target.classList.add('is-in-view');
                    }
                });
            });

            setTimeout(function () {
                animElements.forEach(function (elem) {
                    animObserver.observe(elem);
                });
            }, 15);
        }, 15);

        setTimeout(() => {
            // In View Observer trigger Anims
            const animSelector = '[data-inline-inview]';
            const animElements = [].slice.call(document.querySelectorAll(animSelector));

            const animObserver = new IntersectionObserver(function (elems) {
                elems.forEach(function (elem) {
                    if (elem.intersectionRatio > 0) {
                        elem.target.classList.add('is-in-view');
                    }
                });
            });

            setTimeout(function () {
                animElements.forEach(function (elem) {
                    animObserver.observe(elem);
                });
            }, 15);
        }, 15);
    }

    initFollowNav() {
        const followNav = document.querySelector('.main-nav');

        if (!followNav) {
            return;
        }

        window.addEventListener('scroll', () => {
            if (window.scrollY > followNav.offsetHeight) {
                followNav.classList.add('is-scrolled');
            } else {
                followNav.classList.remove('is-scrolled');
            }
        });
    }

    initTrackingActions() {
        const allHeaderLinks = document.querySelectorAll('#main-nav-wrap a');

        allHeaderLinks.forEach((link) => {
            link.addEventListener('click', () => {
                window.dataLayer = window.dataLayer || [];

                console.log('clic_header', link.innerText);

                window.dataLayer.push({
                    event: 'clic_header',
                    header_element: link.innerText ? link.innerText : 'Logo',
                });
            });
        });

        const allEventsCardsInPage = document.querySelectorAll('.events-item');

        allEventsCardsInPage.forEach((card) => {
            if (card.classList.contains('news-item')) {
                return;
            }

            const cardLinks = card.querySelectorAll('a');

            cardLinks.forEach((cardLink) => {
                cardLink.addEventListener('click', () => {
                    window.dataLayer = window.dataLayer || [];

                    const cardCategories = card.querySelectorAll('.img .categories span');

                    window.dataLayer.push({
                        event: 'clic_event',
                        clic_location: document.querySelector('body').getAttribute('data-section'),
                        show_name: card.querySelector('h2').innerText,
                        show_date: card.querySelector('time')
                            ? card.querySelector('time').innerText
                            : card.querySelector('.time').innerText,
                        show_place: card.querySelector('.salle').innerText,
                        event_type: cardCategories[0] ? cardCategories[0].innerText : '',
                        event_type2: cardCategories[1] ? cardCategories[1].innerText : '',
                        event_type3: cardCategories[2] ? cardCategories[2].innerText : '',
                        event_type4: cardCategories[3] ? cardCategories[3].innerText : '',
                    });
                });
            });
        });

        const allBodySiteBtns = document.querySelectorAll('body main .site-btn');

        const pageEventsDetails = document.querySelector('.EventsDetails');

        if (!pageEventsDetails) {
            allBodySiteBtns.forEach((btn) => {
                btn.addEventListener('click', () => {
                    window.dataLayer = window.dataLayer || [];

                    let btnParent = btn.closest('section');

                    if (!btnParent) {
                        btnParent = btn.closest('div');
                    }

                    window.dataLayer.push({
                        event: 'clic_cta',
                        clic_location: document.querySelector('body').getAttribute('data-section'),
                        clic_bloc:
                            btnParent && btnParent.classList[0]
                                ? btnParent.classList[0]
                                : 'block-infos',
                        clic_name: btn.innerText,
                    });

                    console.log(
                        'allBodySiteBtns',
                        btn.innerText,
                        btn.closest('section') && btn.closest('section').classList[0]
                            ? btn.closest('section').classList[0]
                            : ''
                    );
                });
            });
        }

        const allFooterLinks = document.querySelectorAll('#main-footer a');

        allFooterLinks.forEach((btn) => {
            btn.addEventListener('click', () => {
                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({
                    event: 'clic_footer',
                    clic_bloc: btn.getAttribute('target') ? 'social media' : 'Gestev',
                    clic_name: btn.innerText,
                });
            });
        });

        const logosBlock = document.querySelector('.logos.logos-listing');

        // When block is visible - in view

        if (logosBlock) {
            const logosObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: 'partners_visibility',
                        });
                    }
                });
            });

            logosObserver.observe(logosBlock);
        }

        if (pageEventsDetails) {
            const billetsLinks = pageEventsDetails.querySelectorAll('header .site-btn.billets');
            const followBilletsLinks = pageEventsDetails.querySelectorAll(
                '.fixed-follow-bar .site-btn.billets'
            );
            const rightRailLinks = pageEventsDetails.querySelectorAll('.right-rail a');

            followBilletsLinks.forEach((link) => {
                link.addEventListener('click', () => {
                    window.dataLayer = window.dataLayer || [];

                    window.dataLayer.push({
                        event: 'clic_page_event',
                        clic_name: link.innerText,
                    });

                    console.log('pageEventsDetails followBilletsLinks', link.innerText);
                });
            });

            billetsLinks.forEach((link) => {
                link.addEventListener('click', () => {
                    window.dataLayer = window.dataLayer || [];

                    window.dataLayer.push({
                        event: 'clic_page_event',
                        clic_name: link.innerText,
                    });

                    console.log('pageEventsDetails billetsLinks', link.innerText);
                });
            });

            rightRailLinks.forEach((link) => {
                link.addEventListener('click', () => {
                    window.dataLayer = window.dataLayer || [];

                    window.dataLayer.push({
                        event: 'clic_page_event',
                        clic_name: link.innerText
                            ? link.innerText
                            : link.querySelector('img').getAttribute('alt'),
                    });

                    console.log(
                        'pageEventsDetails rightRailLinks',
                        link.innerText
                            ? link.innerText
                            : link.querySelector('img').getAttribute('alt')
                    );
                });
            });
        }
    }
}

export default new App();
